<template>
  <div v-if="isLoadingUser || isBusinessListLoading" class="loading-container">
    <Spinner />
  </div>
  <div v-else-if="isBusinessListEmpty" class='container'>
    <div style="max-width: 800px; margin: auto;">
      <h1>Welcome to Referberry.</h1>
      <p>Once a referral relationship is set up, all tracking data will be shown here.<br> Questions? Give us a shout at <a href="mailto:hello@referberry.com">hello@referberry.com</a>.</p>
    </div>
  </div>
  <div class="container" v-else>
    <nav class="sidebar">
        <div>
          <Logo />
        </div>
          <router-link class="sidebar-link" :to="'/dashboard'">Metrics</router-link>
          <router-link class="sidebar-link" :to="'/dashboard/partnerships'">Partnerships</router-link>
          <router-link class="sidebar-link" :to="'/dashboard/payments'">Payments</router-link>
          <router-link class="sidebar-link user-control" :to="'/dashboard/settings'">
            {{user.displayName || user.email || ''}}
            <br />
            <span class="business-name">{{currentBusiness.displayName}}</span>
          </router-link>
    </nav>
    <div style="position:relative; flex:1">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './components/Logo'
import Spinner from './components/Spinner'

export default {
  name: 'app',
  data () {
    return {
      visits: 0,
      purchases: 0
    }
  },

  computed: {
    ...mapGetters(['user', 'isLoadingUser', 'isBusinessListLoading', 'currentBusiness', 'isBusinessListEmpty'])
  },

  components: {
    Logo,
    Spinner
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height:100vh
}
.container {
  height:100%;
  display:flex;
  box-orient: horizontal;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: -.02em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.sidebar {
  line-height: 50px;
  background: #f7f8fb;
  min-width: 240px;
  flex:  0;
  text-align: center;
  position: relative;
}
.sidebar-link {
  display: block;
  text-decoration: none;
  color: #333;
  text-align: left;
  padding-left: 50px;
}
.sidebar-link:hover {
  color: #888;
}
.router-link-exact-active {
  font-weight: bold;
  cursor: default;
  color: #FE9B9B !important;
}
.number {
  margin: 10px;
  font-size: 30px;
  font-family: 'Montserrat', sans-serif;
}
h1 {
  font-size: 50px;
  text-align: center;
  color: #777;
  margin: 30px;
}
p {
  font-size: 20px;
  text-align: center;
  color: #555;
  margin: 0;
  line-height: 30px;
}
.user-control {
  padding: 0 15px 0 50px;
  position:absolute;
  bottom:35px;
  line-height: 24px;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.business-name {
  font-size: 14px;
  display: inline-block;
  width: 240px;
  opacity: .7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.page {
  padding: 0 40px;
  background: #fff;
  position: absolute;
  left: 0;
  right: 0;
}

h1 {
  font-size: 50px;
  text-align: left;
  margin: 55px 0;
  color: #555;
}

a {
  color: blue;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

.btn-primary {
  position: relative;
  background: #6c7;
  border-bottom: 2px solid #5a6 !important;
  border-radius: 6px;
  padding: 16px 24px;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  outline: none;
  box-shadow: 0px 0px 3px rgba(0,0,0,.2);
}
.btn-primary:active {
  border-bottom: none !important;
  top: 2px;
  box-shadow:none;
}
.btn-primary:hover {
  opacity: .9;
}

</style>



// WEBPACK FOOTER //
// src/App.vue